import Modal from "components/Modal/Modal";
import Text from "components/Text/Text";
import styles from './feedbackModal.module.scss';
import React from "react";


interface IFeedbackModal {
  isOpen: boolean;
  handleClose: () => void;
  options: string[];
  callback: (opt: string) => void;
}

const FeedbackModal: React.FC<IFeedbackModal> = ({ isOpen, handleClose, options, callback }) => {
  const [textInput, setTextInput] = React.useState('');

  return (
    <Modal isOpen={isOpen} handleClose={handleClose}>
      <div className={styles.modalContent}>
        <div className={styles.modalHeader}>  
          <Text>Tell us why you did not like this response:</Text>
        </div>
        <div className={styles.feedbackContent}>
         {options.map((option) => (
          <div 
            key={option}
            className={styles.feedbackCard}
            onClick={() => callback(option)}
          >
            {option}
          </div>
        ))}
        </div>
        <input
          className={styles.textInput}
          placeholder="The more specific details you can give us, the better..."
          type="text"
          onChange={(e) => setTextInput(e.target.value)}
        />
        <button
          className={styles.submitButton}
          onClick={() => {
            callback(textInput);
            handleClose();
          }}
        >
          Submit
        </button>
      </div>
    </Modal>
  )
}

export default FeedbackModal;